var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operationInformation"},[_c('title1',{attrs:{"title":"运行时间","subTitle":"Electric Port Overview"}}),_c('div',{staticClass:"left-box-right-1-bottom"},[_c('div',{staticClass:"soc"},[_c('div',{staticClass:"bottom"},[_c('soc')],1)]),_c('div',{staticClass:"soh"},[_c('div',{staticClass:"bottom"},[_c('soh')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }